import * as React from "react";

import {
  usePdpWishlistUserExperience,
  WishlistUserExperience_Step,
} from "../providers";

import { StepWishlistAddedFinal } from "./step-wishlist-added-final";

interface WishlistDrawerProps {}
export const WishlistDrawerFragment: React.FunctionComponent<
  WishlistDrawerProps
> = (props) => {
  const { presentingUserExperienceStep } = usePdpWishlistUserExperience();

  return (
    <React.Fragment>
      {presentingUserExperienceStep ===
        WishlistUserExperience_Step.ADDED_TO_WISHLIST_SUCCESS_SCREEN && (
        <StepWishlistAddedFinal />
      )}
    </React.Fragment>
  );
};

export const useWishlistDrawerFragment = (
  presentingUserExperienceStep: `${WishlistUserExperience_Step}`
) => {
  type GeneratedClassName =
    `pdp-wishlist-ux-${Lowercase<WishlistUserExperience_Step>}`;
  const classNameForTheDrawer = React.useMemo((): GeneratedClassName => {
    return `pdp-wishlist-ux-${presentingUserExperienceStep.toLowerCase()}` as GeneratedClassName;
  }, [presentingUserExperienceStep]);

  const value = React.useMemo(
    () => ({
      classNameForTheDrawer,
    }),
    [classNameForTheDrawer]
  );

  return value;
};
